import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TableWrapper = styled.div`
	width: calc(100% - 16px);
	height: auto;
	position: relative;

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		margin-left: 32px;
		font-family: 'Roboto';
		font-weight: ${props => (props.isSelectedCompany ? 600 : 'normal')};
		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
			border: none;
		}

		.ag-root-wrapper {
			border-bottom: 1px solid ${colors.grey3};
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			background-color: transparent;
			border: none;
		}

		.ag-header-cell {
			font-weight: normal;
			font-size: 13px;
			letter-spacing: 0.3px;
			padding-bottom: 5px;
			color: ${colors.grey5};

			&::after {
				display: none;
			}
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey7};
			}
			&.with-tooltip {
				overflow: visible;
			}
			&.missing-data-row {
				.ag-cell.vendor-title {
					color: ${colors.grey3};
				}
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}

		.categories-column.ag-cell {
			padding-right: 0px;
			text-align: left;
		}

		.categories-icon-column.ag-cell {
			padding-left: 0px;
			padding-right: 0px;
		}

		.ag-row {
			svg {
				visibility: hidden;
			}
			&.ag-row-hover {
				svg {
					visibility: visible;
					&:hover {
						fill: ${colors.grey8};
					}
				}
			}
		}
	}
`;

export const CategoryIconWrapper = styled.div`
	height: 100%;
	width: 100%;
	svg {
		margin-top: -1px;
	}
`;

export const Container = styled.div`
	width: 520px;
	margin-top: 24px;
	margin-left: -12px;
`;

export const Title = styled.div`
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.3px;
	font-weight: 500;
	margin: 4px 0;
`;

export const TooltipContent = styled.div`
	padding: 12px;
	font-size: 11px;
	text-align: left;
	z-index: 10;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
`;

export const CellContainer = styled.div`
	position: relative;
`;

export const TooltipContainer = styled.div`
	position: absolute;
	top: -30px;
	background-color: ${colors.white};
`;

export const MenuWrapper = styled.div`
	position: absolute;
	top: ${props => props.top - 6 || 0}px;
	left: 0;
	width: 32px;
	height: 32px;
`;
